import asReduxFormField from '../asReduxFormField';
import wrapFormField from '../wrapFormField';
import FoxHtmlEditor from './FoxHtmlEditor';

export default wrapFormField(asReduxFormField(FoxHtmlEditor));
